// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CreateCashAdvancesBatchInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/create_cash_advances_batch
 *
 * Validates input for creating multiple employee advances from cash recebimentos at once.
 */
import { registerContract } from './validate'

export interface Payroll_CreateCashAdvancesBatchInput {
period_id: number
recebimento_ids: number[]
franchise_id: number
}

registerContract('Payroll_CreateCashAdvancesBatchInput', {
  period_id:       { type: 'number',  required: true },
  recebimento_ids: { type: 'array',   required: true },
  franchise_id:    { type: 'number',  required: true },
})
